import auth from '@/router/auth'
import PaymentIndex from '@/components/payments/Index'
import PaymentShow from '@/components/payments/Show'

export default [
  {
    path: '/payments',
    name: 'payments-index',
    component: PaymentIndex,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/payments/show/:payment_id',
    name: 'payments-show',
    component: PaymentShow,
    beforeEnter: auth.requireAuth
  }
]



// WEBPACK FOOTER //
// ./src/components/payments/router.js